import fails$1 from './fails.js';

var fails = fails$1; // Detect IE8's incomplete defineProperty implementation

var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] != 7;
});

export { descriptors as default };
